import _ from 'lodash';

import { IOrder, IOrderDetails, IProduct, IOrderProductsMap } from "@/service/types";

export interface IProductValidation {
  quantity: number,
  product?: IProduct
}

export interface IProductValidationDict {
  [index: string]: IProductValidation
}

export interface IValidationContext {
  productValidation: IProductValidationDict
}

export interface IOrderDetailedDict {
  [orderId: number]: IOrderDetails
}

export enum MessageType {
  Success,
  Info,
  Warning,
  Danger
}

export enum ValidationStatus {
  Ok,
  TooFew,
  TooMuch,
  Extraneous,
  OtherError
}

export interface IOrderValidationMessage {
  type: MessageType,
  value: string
}

export interface IOrdersValidationContextDict {
  [orderId: number]: IValidationContext
}

export interface IProductDict {
  [index: string]: IProduct
}

export interface IOrderState {
  orders: Array<IOrder>,
  searchQuery: string,
  ordersDetailed: IOrderDetailedDict,
  ordersValidationContext: IOrdersValidationContextDict,
  orderProductsMap: IOrderProductsMap,
  queue: Array<IQueueElement>,
  nextPossibleUpdateTime: number, 
}

export interface IValidationWrappedProduct {
  product?: IProduct,
  validation?: IProductValidation,
  state: ValidationStatus
}

export interface IValidationWrappedProductDict{
  [index: string]: IValidationWrappedProduct
}

export interface IGeneralMessagesDict{
  [index: string]: IOrderValidationMessage
}

export interface IValidationProcess{
  products: IValidationWrappedProductDict,
  generalMessages: IGeneralMessagesDict,
  valid: boolean,
  pristine: boolean
}

// params interfaces
export interface IParamUpdateQuantity {
  orderId: number,
  productIndex: string,
  quantity: number,
  product?: IProduct
}

export interface IParamUpdateValidationProduct {
  orderId: number,
  productEan: string,
  product: IProduct,
}

export interface IProductStateDict {
  [index: string]: IProduct
}

export function isIProductStateDict(param: any): param is IProductStateDict {
  return _.isObject(param) && _.isString(_.first(_.keys(param)));
}

export interface IProductState {
  products: IProductStateDict,
  otherProducts: IProductStateDict,
}

export interface IQueueElement {
  actionType: string,
  idOrder: number
}